import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { AuthenticationService } from 'authentication-data';
import { BranchesApi, BranchLocation } from '@idealsupply/ngclient-webservice-branches';
import { withCachedEntityStore } from 'state-data';

export interface BranchEntity {
  id: number;
}

export const BranchDetailsStore = signalStore(
  { providedIn: 'root' },
  withCachedEntityStore({
    selectId: (p: BranchLocation) => p.branchId!,
    load: (id: number) => {
      const user = inject(AuthenticationService).user;
      return inject(BranchesApi).getLocation(id).pipe();
    },
    cacheSeconds: 60,
  }),
);

// static getBranchAlias(branchId: number): string {
//   // Get the branch alias from the branchAliases object
//   return branchAliases[this.resolveCountryCode('EN')][branchId] ?? branchId.toString();
//   // If the branchId is not found, return the branchId as a string

// }
